import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a9f5454"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "banner"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" This is the \"old\" version of the Monarch UI version 3.0. It will be deleted soon and should not be used or referenced. See "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://github.com/monarch-initiative/monarch-ui-new" }, " the readme "),
  /*#__PURE__*/_createTextVNode(" for more info. ")
], -1))

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TheBanner',
  setup(__props) {

const open = ref(true);

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!

  return (open.value)
    ? (_openBlock(), _createElementBlock("aside", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_AppButton, {
          icon: "times",
          text: "Close",
          design: "small",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (open.value = false))
        })
      ]))
    : _createCommentVNode("", true)
}
}

})